import {
  TIMESTAMP_ALL,
  TIMESTAMP_GET,
  TIMESTAMP_DEL,
  TIMESTAMP_PUT,
  TIMESTAMP_POST,
  TIMESTAMP_LOADING,
  TIMESTAMP_ERROR,
  TIMESTAMP_RESET,
  TIMESTAMP_PAYROLL_ALL,
  TIMESTAMP_PENDING_APPROVAL_COUNT,
} from '../types';

import api from '../../../utils/functions/api';

export const timestampHrCheckin = (payload) => async (dispatch) => {
  try {
    dispatch({ type: TIMESTAMP_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/timestamp/with-hr`,
      payload,
    );
    dispatch({ type: TIMESTAMP_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

export const timestampCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: TIMESTAMP_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/timestamp`,
      payload,
    );
    dispatch({ type: TIMESTAMP_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw error;
  }
};

export const timestampApprove = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: TIMESTAMP_LOADING });
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/timestamp/${id}/approval`,
      payload,
    );
    dispatch({ type: TIMESTAMP_PUT, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw error;
  }
};

export const timestampAll = (params) => async (dispatch) => {
  try {
    dispatch({ type: TIMESTAMP_LOADING });
    const {
      name = '',
      size = 999999,
      page = 1,
      me = '',
      project_id = '',
      emSelect = { _id: '' },
      ot = '',
      dateStart = '',
      dateEnd = '',
      cal = '',
      sort = '',
      dash = '',
      roleSelect = { _id: '' },
      profile = '',
      typeSelect = '',
      employeekey = '',
      approval_status = '',
      out_of_location = '',
    } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/timestamp?name=${name}&size=${size}&page=${page}&me=${me}&project_id=${project_id}&em=${emSelect?._id}&ot=${ot}&dateStart=${dateStart}&dateEnd=${dateEnd}&cal=${cal}&sort=${sort}&role=${roleSelect?._id}&dash=${dash}&profile=${profile}&type=${typeSelect}&employeekey=${employeekey}&approval_status=${approval_status}&out_of_location=${out_of_location}`,
    );
    if (status === 200) {
      dispatch({ type: TIMESTAMP_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

export const timestampManpower = (params) => async (dispatch) => {
  try {
    const {
      name = '',
      size = 999999,
      page = 1,
      me = '',
      project_id = '',
      emSelect = { _id: '' },
      ot = '',
      dateStart = '',
      dateEnd = '',
      cal = '',
      sort = '',
      dash = '',
      roleSelect = { _id: '' },
      profile = '',
      typeSelect = '',
      employeekey = '',
    } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/timestamp/manppower/check?name=${name}&size=${size}&page=${page}&me=${me}&project_id=${project_id}&em=${emSelect?._id}&ot=${ot}&dateStart=${dateStart}&dateEnd=${dateEnd}&cal=${cal}&sort=${sort}&role=${roleSelect?._id}&dash=${dash}&profile=${profile}&type=${typeSelect}&employeekey=${employeekey}`,
    );
    if (status === 200) {
      dispatch({ type: TIMESTAMP_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

export const timestampDaily = (params) => async (dispatch) => {
  try {
    const {
      me = '',
      project_id = '',
      dateStart = '',
      dateEnd = '',
      typeSelect = '',
    } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/timestamp/daily?me=${me}&project_id=${project_id}&dateStart=${dateStart}&dateEnd=${dateEnd}&typeSelect=${typeSelect}`,
    );
    if (status === 200) {
      dispatch({ type: TIMESTAMP_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

export const timestampDashboard = (params) => async (dispatch) => {
  try {
    const { me = '', project_id = '', dateStart = '', dateEnd = '' } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/timestamp/dashboard?me=${me}&project_id=${project_id}&dateStart=${dateStart}&dateEnd=${dateEnd}`,
    );
    if (status === 200) {
      dispatch({ type: TIMESTAMP_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

export const timestampPayrollDashboard = (params) => async (dispatch) => {
  try {
    const { dateStart = '', dateEnd = '', typeSelect = '' } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/timestamp/timestamp-payroll-dashboard?dateStart=${dateStart}&dateEnd=${dateEnd}&typeSelect=${typeSelect}`,
    );
    if (status === 200) {
      dispatch({ type: TIMESTAMP_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

export const timestampPayroll = (params) => async (dispatch) => {
  try {
    const { dateStart = '', dateEnd = '', typeSelect = '' } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/timestamp/timestamp-payroll?dateStart=${dateStart}&dateEnd=${dateEnd}&typeSelect=${typeSelect}`,
    );
    if (status === 200) {
      dispatch({ type: TIMESTAMP_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

// แยก store key เพื่อใช้คู่กับ timestampPayrollDashboard บนหน้าเดียวกัน
export const timestampPayrollFetch = (params) => async (dispatch) => {
  try {
    const { dateStart = '', dateEnd = '', typeSelect = '' } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/timestamp/timestamp-payroll?dateStart=${dateStart}&dateEnd=${dateEnd}&typeSelect=${typeSelect}`,
    );
    if (status === 200) {
      dispatch({ type: TIMESTAMP_PAYROLL_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
};

// ดึงข้อมูลทั้ง 2 stores — TIMESTAMP_ALL ต้องมาจาก timestamp-payroll-dashboard (คำนวณชั่วโมงด้วย
// calcEffectiveWorkMinutes: เริ่มนับ 08:00, cap 17:00, ไม่นับพักเที่ยง) ไม่ใช่ timestamp-payroll ธรรมดา
// (ใช้ caltotalTimeBefore ซึ่งนับชั่วโมงดิบแล้ว cap ที่ 8 เท่านั้น ทำให้กะข้ามคืนได้ 8 ชม.ผิดๆ)
export const timestampPayrollFetchBoth = (params) => async (dispatch) => {
  try {
    const { dateStart = '', dateEnd = '', typeSelect = '' } = params;
    const [dashboardRes, payrollRes] = await Promise.all([
      api.get(
        `${process.env.REACT_APP_API_URL}/timestamp/timestamp-payroll-dashboard?dateStart=${dateStart}&dateEnd=${dateEnd}&typeSelect=${typeSelect}`,
      ),
      api.get(
        `${process.env.REACT_APP_API_URL}/timestamp/timestamp-payroll?dateStart=${dateStart}&dateEnd=${dateEnd}&typeSelect=${typeSelect}`,
      ),
    ]);
    if (dashboardRes.status === 200) {
      dispatch({ type: TIMESTAMP_ALL, payload: dashboardRes.data });
    }
    if (payrollRes.status === 200) {
      dispatch({ type: TIMESTAMP_PAYROLL_ALL, payload: payrollRes.data });
    }
    return { dashboard: dashboardRes.data, payroll: payrollRes.data };
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
};

export const timestampCheckin = (params) => async (dispatch) => {
  try {
    const {
      name = '',
      size = 200,
      page = 1,
      me = '',
      project_id = '',
      emSelect = { _id: '' },
      checkoutem = '',
    } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/timestamp/checkin?name=${name}&size=${size}&page=${page}&me=${me}&project_id=${project_id}&em=${emSelect?._id}&checkoutem=${checkoutem}`,
    );
    if (status === 200) {
      dispatch({ type: TIMESTAMP_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

export const timestampGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/timestamp/${id}`,
    );
    if (status === 200) {
      dispatch({ type: TIMESTAMP_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

export const timestampPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: TIMESTAMP_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/timestamp/${id}`,
      payload,
    );
    dispatch({ type: TIMESTAMP_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};
export const timestampSalaryOverride = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/timestamp/${id}/salary-override`,
      payload,
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const timestampSkipLate = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/timestamp/${id}/skip-late`,
      payload,
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const timestampUpdateProject = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/timestamp/${id}/project`,
      payload,
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const timestampClearTimeOverride = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`${process.env.REACT_APP_API_URL}/timestamp/${id}/checkin-time`);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const timestampClearProjectOverride = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`${process.env.REACT_APP_API_URL}/timestamp/${id}/project`);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const timestampUpdateCheckInTime = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/timestamp/${id}/checkin-time`,
      payload,
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const timestampFetchOne = (id) => async (dispatch) => {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_API_URL}/timestamp/${id}`);
    return data?.result ?? data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const timestampHourOverride = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/timestamp/${id}/hour-override`,
      payload,
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const timestampToggleOtOverride = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/timestamp/${id}/ot-override`,
      payload,
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const timestampManualDay = (payload) => async (dispatch) => {
  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/timestamp/manual-day`,
      payload,
    );
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const timestampPutSalary = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: TIMESTAMP_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/timestamp/labour/${id}`,
      payload,
    );
    dispatch({ type: TIMESTAMP_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

export const timestampOtRequire = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: TIMESTAMP_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/timestamp/ot/${id}`,
      payload,
    );
    dispatch({ type: TIMESTAMP_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};
export const timestampDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: TIMESTAMP_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/timestamp/${id}`,
    );
    dispatch({ type: TIMESTAMP_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

export const timestampReset = () => async (dispatch) => {
  try {
    dispatch({ type: TIMESTAMP_RESET });
  } catch (error) {
    console.error(error);
    dispatch({ type: TIMESTAMP_ERROR });
    throw new Error(error);
  }
};

export const timestampLogPrint = (payload) => async () => {
  try {
    await api.post(
      `${process.env.REACT_APP_API_URL}/timestamp/log-print`,
      payload,
    );
  } catch (error) {
    console.error('Failed to log print activity:', error);
  }
};

export const timestampPendingApprovalCount = () => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/timestamp?approval_status=PENDING&out_of_location=true&size=1&page=1`,
    );
    if (status === 200) {
      const count = data?.total ?? data?.rows?.length ?? 0;
      dispatch({ type: TIMESTAMP_PENDING_APPROVAL_COUNT, payload: count });
    }
  } catch (error) {
    console.error(error);
  }
};
